import React from 'react';
import { Outlet } from 'react-router-dom';
import { Footer } from '../../../components/Footer/Footer';
import { Menu } from '../../../components/Menu/Menu';

interface GenericLayoutProps {}

export const GenericLayout: React.FC<GenericLayoutProps> = () => {
  return (
    <div>
      <Menu></Menu>
      <Outlet />
      <Footer></Footer>
    </div>
  );
};
